import { useMemo } from "react";

/** Application id from the URL must be a UUID or numeric record id. */
export function isValidApplicationId(id: string | undefined | null): boolean {
  if (id == null) return false;
  const s = String(id).trim();
  if (!s) return false;
  const isUuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      s,
    );
  const isNumeric = /^\d+$/.test(s);
  return isUuid || isNumeric;
}

export function useApplicationId(): string {
  return useMemo(() => {
    try {
      if (typeof window === "undefined") return "";

      const url = new URL(window.location.href);
      const segments = url.pathname.split("/").filter(Boolean);

      const first = segments[0] ?? "";
      if (isValidApplicationId(first)) return first;

      const found = segments.find((s) => isValidApplicationId(s));
      return found ?? "";
    } catch {
      return "";
    }
  }, []);
}
